<template>
  <div class="liquor-header-select">
    <div class="buttons" :style="`width: ${list.length * 110}px`">
      <div
        class="button"
        :class="{'button-active': item.active}"
        :style="(index > 0 && index < list.length - 1) ? 'border-left: none; border-right: none' : ''"
        v-for="(item, index) in list"
        :key="index"
        @click="onClick(item)"
      >{{item.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiquorHeaderSelect",
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClick(e) {
      this.$router.push(e.link);
    }
  }
};
</script>

<style lang="scss">
.liquor-header-select {
  width: 100vw;
  height: 60px;

  position: fixed;
  top: 70px;
  z-index: 999;
  background: rgba(0, 0, 0, 1);

  .buttons {
    margin: 15px auto;
    height: 28px;

    .button {
      vertical-align: top;
      display: inline-block;
      width: 108px;
      border: 1px solid rgba(228, 200, 150, 1);
      height: 28px;
      line-height: 28px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: rgba(228, 200, 150, 1);
      background: rgba(0, 0, 0, 1);
      cursor: pointer;
    }

    .button-border {
      display: inline-block;
      width: 1px;
      height: 28px;
    }

    .button-active {
      background: rgba($color: #e4c896, $alpha: 1);
      color: #000000;
      cursor: default;
    }
  }
}
</style>